import React, { CSSProperties, useEffect, useImperativeHandle, useState } from 'react';
import { Label, Stack, TextField } from '@fluentui/react';

export interface ITextCompProps {
    validate: RegExp;
    required?: boolean;
    label?: string;
    onChange: Function;
    value?: string;
    style?: CSSProperties;
}

export const TextComp : React.FunctionComponent<ITextCompProps> = (props: ITextCompProps) => {
    const [value, set_value] = useState<string>();
    const [errors, set_errors] = useState<Array<string>>([]);
    const [doVal, set_doVal] = useState<number>();

    useEffect(() => {
        if (props.required) {
            if (value) {
                props.onChange(value);
            } else {
                props.onChange(null);
            }
        } else {
            props.onChange(value);
        }
    },[value]);

    useEffect(() => {
        if (props.value) {
            set_value(props.value);
        }
    },[props.value])

    useEffect(() => {
        if (doVal) {
            let errors : Array<string> = [];
            if (props.required && (value === undefined || value.length === 0)) {
                errors.push("Dit veld is verplicht");
                props.onChange(null);
            } else if (!value?.match(props.validate)) {
                errors.push("Geen juiste waarde");
                props.onChange(null);
            }
            set_errors(errors);
        }
    }, [doVal]);

    function ReValidate() {
        if (doVal) {
            set_doVal(Date.now);
        }
    }

    return (
        <Stack style={props.style}>
            <TextField required={props.required ? true : false} label={props.label} maxLength={50} value={value} onChange={(e,v) => { set_value(v); ReValidate(); }} onBlur={()=>{ set_doVal(Date.now); }} />
            {errors.map(error => {
                return <Label key={error} style={{color:"red",fontSize:"small"}}>{error}</Label>
            })}
        </Stack>
    );
};